import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared/shared.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart/cart.service';
import { Storage } from '@ionic/storage';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConsoleService } from 'src/app/services/console/console.service';
import {SafeStyle , DomSanitizer} from '@angular/platform-browser';


@Component({
    selector: 'app-widget-product-list',
    templateUrl: './widget-product-list.component.html',
    styleUrls: ['./widget-product-list.component.scss'],
})
export class WidgetProductListComponent implements OnInit {

    @Input() cartProducts = [];

    @Input() role: string;
    @Input() userId: string;
    @Input() showPrices: any;
    @Input() widgetID: any;
    @Input() widgetTitle: any;
    products = [];
    noProducts = true;
    cartSub: Subscription;
    priceForRetail = false;
    widgetStyle:any;
    backgroundColor = '#fff';
    background:any ;
    widgetData:any;

    constructor(
        private sharedService: SharedService,
        private widgetsService: WidgetsService,
        private cartService: CartService,
        private storage: Storage,
        private consoleService:ConsoleService,
        private domSanitizer:DomSanitizer,
        private configService: ConfigService) { }

    async ngOnInit() {
        this.cartProducts = this.cartService.getCartProducts();
        this.priceForRetail = this.configService.environment.priceForRetail;
        this.initializeSubscriptions();
    }

    ngOnDestroy(): void {
      this.cartSub.unsubscribe();
    }

    async initializeSubscriptions() {
        this.cartSub = this.cartService.getCartProductsListener().subscribe((cartProducts) => {
            this.cartProducts = cartProducts;
        }); 

        this.widgetData = await this.widgetsService.getWidgetData(this.widgetID);
        this.consoleService.consoleLog('widget-product-list:62', this.widgetData)
        if (this.widgetData && this.widgetData.style && Object.keys(this.widgetData.style).length != 0) {
            this.widgetStyle = this.widgetData.style;
            this.consoleService.consoleLog('widget-product-list:63 - widgetStyle', this.widgetStyle) 
            if(this.widgetStyle.widgetStyle && this.widgetStyle.widgetStyle.backgroundImage){
                this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.widgetStyle.backgroundImage})`);
                //this.consoleService.consoleLog('widget-product-list.component.html:64 - backgroundImage', this.backgroundImage) 
            }
            else if(this.widgetStyle.widgetStyle && this.widgetStyle.widgetStyle.
                backgroundColor){
                this.background = this.widgetStyle.widgetStyle.backgroundColor;
            }
            else{
               // this.background = 'transparent';
            }
        }
        

        let products: any = await this.widgetsService.getProductsForCarousel(this.widgetID);
        if(products && products.length) {
            for (let product of products) {
                product = await this.prepareProductData(product.data);
                product = this.prepareProductForView(product);
            }
            this.products = products;
            this.noProducts = false;
        }

    }

    async prepareProductData(product: any) {
        const wishlistProducts = await this.storage.get('wishlistProducts');
        const subRole = await this.storage.get('userSubRole');
        const userId = await this.storage.get('uid');
        const data = {
            wishlistProducts,
            subRole,
            userId,
            product,
            cartProducts: this.cartProducts
        }
        const updatedProduct = await this.sharedService.prepareProductData(data);
        return updatedProduct;
    }

    prepareProductForView(item) {
        const newObj = {};
        const { id, cartQty, cartId, isWishlisted, ...data } = item;
        newObj['data'] = data;
        newObj['id'] = id;
        newObj['cartQty'] = cartQty;
        newObj['cartId'] = cartId;
        newObj['isWishlisted'] = isWishlisted;

        return newObj;
    }

}

